import React from 'react';
import { IVerifiedTokenProps, IVerifiedTokenState, IRootState } from '../../interfaces';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { verifiedTokenRequest } from '../../action';
import * as qs from 'query-string';

class VerifiedToken extends React.Component<IVerifiedTokenProps, IVerifiedTokenState> {
  constructor(props: IVerifiedTokenProps) {
    super(props);
    this.state = {
      token: ""
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { search } = location;
    const query = qs.parse(search);
    var full = window.location.host
    //window.location.host is subdomain.domain.com
    var parts = full.split('.')
    var subDomain = parts[0]
    if (query && query.token) {
      localStorage.setItem('userToken', query.token as string)
      if (this.props.verifiedToken) {
        this.props.verifiedToken();
      }
    }
  }


  render() {
    return (<div></div>);
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  verifiedTokenReducer: state.verifiedTokenReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    verifiedToken: () => {
      dispatch(verifiedTokenRequest());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VerifiedToken);